import type { DatePickerProps } from 'antd';
import { DatePicker as AntDatePicker } from 'antd';
import { FC, useId } from 'react';
import { DENOMINATOR_DATE_FORMAT, REFERENCE_DATE_FORMAT, YEAR_FORMAT } from 'src/shared/consts/date';
import { InputWrapper } from '../_shared/InputWrapper';
import s from './DatePicker.module.scss';

interface Props extends DatePickerProps {
	label?: string;
	error?: string;
}

export const DatePicker: FC<Props> = props => {
	const {
		label, //
		error,
		picker,
		className,
		...datePickerProps
	} = props;

	const id = useId();

	picker === 'month';

	const format: Record<'time' | 'date' | 'week' | 'month' | 'quarter' | 'year' | 'decade', string> = {
		time: DENOMINATOR_DATE_FORMAT,
		date: DENOMINATOR_DATE_FORMAT,
		week: DENOMINATOR_DATE_FORMAT,
		month: REFERENCE_DATE_FORMAT,
		quarter: DENOMINATOR_DATE_FORMAT,
		year: YEAR_FORMAT,
		decade: DENOMINATOR_DATE_FORMAT,
	};

	// * Render
	return (
		<InputWrapper
			label={label}
			error={error}
			className={className}
			id={id}
		>
			<div>
				<AntDatePicker
					{...datePickerProps}
					className={s.input}
					id={id}
					format={{
						format: picker ? format[picker] : DENOMINATOR_DATE_FORMAT,
						type: 'mask',
					}}
					picker={picker}
				/>
			</div>
		</InputWrapper>
	);
};
